<p-confirmDialog appendTo="body"></p-confirmDialog>
<p-dialog
    [visible]="visible"
    (visibleChange)="visibleChange.emit($event)"
    [modal]="true"
    [header]="title"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: 'min(980px, 94vw)' }"
    [breakpoints]="{ '860px': '96vw' }"
    styleClass="master-create-dialog">
    <section class="master-dialog-body">
        <aside class="master-dialog-summary">
            <div class="summary-icon">
                <i [class]="resolvedMode === 'location' ? 'pi pi-map-marker' : resolvedMode === 'company' ? 'pi pi-building' : resolvedMode === 'transportationAgency' ? 'pi pi-truck' : resolvedMode === 'driver' ? 'pi pi-id-card' : resolvedMode === 'shipper' ? 'pi pi-send' : resolvedMode === 'broker' || resolvedMode === 'brokerContact' ? 'pi pi-shield' : resolvedMode === 'employee' ? 'pi pi-users' : resolvedMode === 'laborer' ? 'pi pi-briefcase' : resolvedMode === 'customsAgent' ? 'pi pi-verified' : 'pi pi-user'"></i>
            </div>
            <div>
                <small>{{ summaryEyebrow }}</small>
                <h3>{{ summaryTitle }}</h3>
                <p>{{ summaryText }}</p>
            </div>
            <div class="master-dialog-facts">
                <div>
                    <span>{{ primaryFactLabel }}</span>
                    <strong>{{ primaryFactValue }}</strong>
                </div>
                <div>
                    <span>{{ secondaryFactLabel }}</span>
                    <strong>{{ secondaryFactValue }}</strong>
                </div>
            </div>
        </aside>

        <form [formGroup]="form" class="master-dialog-form">
            @if (errorMessage) {
                <small class="p-error master-wide-field save-error">{{ errorMessage }}</small>
            }

            @if (resolvedMode === 'customer' && showCompanySelector && form.get('companyId')) {
                <p-inputGroup class="master-wide-field">
                    <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <p-select inputId="companyId" formControlName="companyId" [options]="companyOptions" optionLabel="name" [filter]="true" filterBy="name" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
                        <label for="companyId">Company</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if (showAddressSearch && form.get('address')) {
                <p-inputGroup class="master-wide-field">
                    <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <app-location-search formControlName="address" (placeSelected)="placeSelected($event)" class="w-full"></app-location-search>
                        <label for="address">Address / Google Place</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if ((resolvedMode === 'company' || resolvedMode === 'transportationAgency' || resolvedMode === 'broker' || resolvedMode === 'brokerContact' || resolvedMode === 'shipper' || resolvedMode === 'customer' || resolvedMode === 'employee' || resolvedMode === 'laborer' || resolvedMode === 'customsAgent' || resolvedMode === 'driver' || resolvedMode === 'location') && form.get('name')) {
                <p-inputGroup class="master-wide-field">
                    <p-inputGroupAddon><i [class]="resolvedMode === 'location' ? 'pi pi-map-marker' : resolvedMode === 'company' ? 'pi pi-building' : resolvedMode === 'transportationAgency' ? 'pi pi-truck' : resolvedMode === 'shipper' ? 'pi pi-send' : resolvedMode === 'broker' || resolvedMode === 'brokerContact' ? 'pi pi-shield' : resolvedMode === 'driver' ? 'pi pi-id-card' : resolvedMode === 'employee' ? 'pi pi-users' : resolvedMode === 'laborer' ? 'pi pi-briefcase' : resolvedMode === 'customsAgent' ? 'pi pi-verified' : 'pi pi-user'"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input [id]="resolvedMode + 'Name'" pInputText formControlName="name" />
                        <label [for]="resolvedMode + 'Name'">
                            {{ resolvedMode === 'company' ? 'Company Name *' : resolvedMode === 'transportationAgency' ? 'Agency Name *' : resolvedMode === 'broker' ? 'Broker Name *' : resolvedMode === 'brokerContact' ? 'Broker Contact Name *' : resolvedMode === 'shipper' ? 'Shipper Name *' : resolvedMode === 'driver' ? 'Driver Name *' : resolvedMode === 'location' ? 'Location Name *' : resolvedMode === 'employee' ? 'Employee Name *' : resolvedMode === 'laborer' ? 'Laborer Name *' : resolvedMode === 'customsAgent' ? 'Customs Agent Name *' : 'Customer Name *' }}
                        </label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if (showCountryField && form.get('countryId')) {
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-flag"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <p-select inputId="countryId" formControlName="countryId" [options]="countries" optionLabel="name" optionValue="id" [filter]="true" appendTo="body" styleClass="w-full" (onChange)="onCountryFieldChange($event.value)"></p-select>
                        <label for="countryId">{{ resolvedMode === 'driver' ? 'Residing Country *' : 'Country *' }}</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if (resolvedMode === 'location' || resolvedMode === 'driver') {
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-map"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <p-select inputId="cityId" formControlName="cityId" [options]="cities" optionLabel="cityName" optionValue="id" [filter]="true" appendTo="body" styleClass="w-full"></p-select>
                        <label for="cityId">{{ resolvedMode === 'driver' ? 'Residing City *' : 'City *' }}</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if ((resolvedMode === 'company' || resolvedMode === 'broker' || resolvedMode === 'transportationAgency') && form.get('crNumber')) {
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input [id]="resolvedMode + 'Cr'" pInputText type="number" formControlName="crNumber" />
                        <label [for]="resolvedMode + 'Cr'">CR Number{{ resolvedMode === 'company' || resolvedMode === 'transportationAgency' ? ' *' : '' }}</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if (resolvedMode === 'transportationAgency') {
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-ticket"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input id="motAgencyLicenseNumber" pInputText formControlName="motAgencyLicenseNumber" />
                        <label for="motAgencyLicenseNumber">MOT License Number</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if (resolvedMode === 'company' && form.get('taxRegNumber')) {
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-receipt"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input id="taxRegNumber" pInputText formControlName="taxRegNumber" />
                        <label for="taxRegNumber">VAT Number</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if (showCompanySelector && resolvedMode !== 'customer' && form.get('companyId')) {
                <p-inputGroup class="master-wide-field">
                    <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <p-select inputId="companyId" formControlName="companyId" [options]="companyOptions" optionLabel="name" [filter]="true" filterBy="name" appendTo="body" styleClass="w-full"></p-select>
                        <label for="companyId">Company *</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if ((resolvedMode === 'customer' || resolvedMode === 'employee' || resolvedMode === 'laborer' || resolvedMode === 'brokerContact' || resolvedMode === 'customsAgent') && form.get('corporateRole')) {
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input id="corporateRole" pInputText formControlName="corporateRole" />
                        <label for="corporateRole">{{ resolvedMode === 'employee' ? 'Job Title' : resolvedMode === 'laborer' ? 'Skill / Role' : resolvedMode === 'brokerContact' ? 'Broker Role' : resolvedMode === 'customsAgent' ? 'Clearance Role' : 'Role' }}</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if (form.get('phoneNumber')) {
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-phone"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input id="phoneNumber" pInputText formControlName="phoneNumber" [placeholder]="phonePlaceholder" />
                        <label for="phoneNumber">Phone{{ resolvedMode === 'company' || resolvedMode === 'employee' || resolvedMode === 'laborer' || resolvedMode === 'brokerContact' || resolvedMode === 'customsAgent' || resolvedMode === 'transportationAgency' || resolvedMode === 'driver' ? ' *' : '' }}</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if (form.get('emailAddress')) {
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-envelope"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input id="emailAddress" pInputText formControlName="emailAddress" />
                        <label for="emailAddress">Email</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if (resolvedMode === 'customer' && form.hasError('emailOrPhoneRequired') && (form.touched || form.dirty)) {
                <small class="p-error master-wide-field">Enter either an email or a phone number.</small>
            }

            @if (form.get('websiteURL')) {
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-globe"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input id="websiteURL" pInputText formControlName="websiteURL" />
                        <label for="websiteURL">Website</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if (form.get('residenceNumber')) {
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-id-card"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input id="residenceNumber" pInputText formControlName="residenceNumber" />
                        <label for="residenceNumber">Residence Number *</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if (form.get('residenceExpiryDate')) {
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input id="residenceExpiryDate" pInputText type="number" formControlName="residenceExpiryDate" />
                        <label for="residenceExpiryDate">Residence Expiry *</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if (form.get('licenseNumber')) {
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-car"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input id="licenseNumber" pInputText formControlName="licenseNumber" />
                        <label for="licenseNumber">License Number *</label>
                    </p-iftalabel>
                </p-inputGroup>
            }

            @if (form.get('licenseExpiryDate')) {
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-calendar-clock"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input id="licenseExpiryDate" pInputText type="number" formControlName="licenseExpiryDate" />
                        <label for="licenseExpiryDate">License Expiry *</label>
                    </p-iftalabel>
                </p-inputGroup>
            }
        </form>
    </section>

    <ng-template pTemplate="footer">
        <div class="master-dialog-footer">
            <p-button type="button" label="Reset" icon="pi pi-refresh" severity="secondary" [outlined]="true" (click)="buildForm()"></p-button>
            <span class="footer-spacer"></span>
            <p-button type="button" label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="close()"></p-button>
            <p-button type="button" [label]="submitActionLabel" icon="pi pi-save" [loading]="saving" (click)="save()"></p-button>
        </div>
    </ng-template>
</p-dialog>
